import { memo } from "react";

import Facebook from "../../../../../public/assets/icon/sns/facebook.svg?react";
import { IconCreator } from "../_utils/icon-creator";

import type { SVGIconProps } from "../_utils/icon-creator";

const FacebookIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Facebook });
	return <Icon />;
};

export default memo(FacebookIcon);
